import { useState } from 'react';
import { useMutation } from '@apollo/client';
import PreferencesFormData from '../interfaces/PreferencesFormData';
import { UserAboutMeInput } from 'graphql.generated';
import { UPDATE_ABOUT_ME_MUTATION } from './useUpdateAboutMe.queries';

const useUpdateAboutMe = (onSuccess?: () => void) => {
    const [generalError, setGeneralError] = useState(false);

    const [aboutMeMutation] = useMutation<
        { updateUserAboutMe: boolean },
        { input: UserAboutMeInput }
    >(UPDATE_ABOUT_ME_MUTATION, {
        onCompleted({ updateUserAboutMe: response }) {
            if (!response) {
                setGeneralError(true);
                return;
            }
            onSuccess?.();
        },
        onError() {
            setGeneralError(true);
        }
    });

    const updateAboutMe = (props: PreferencesFormData) => {
        setGeneralError(false);

        const { situation } = props;
        if (!situation) {
            return;
        }

        const input: UserAboutMeInput = {
            situation: situation
        };

        return aboutMeMutation({
            variables: {
                input
            }
        });
    };

    return {
        updateAboutMe,
        generalError
    };
};

export default useUpdateAboutMe;
